<template>
  <div class="TestDetails">
    <div class="content-header">
      <div class="container">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">Test Details</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/tests">Tests</router-link>
              </li>
              <li class="breadcrumb-item active">Details</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-light">
              <div class="card-body">
                <!--  -->
                <!-- <p>
                  <router-link :to="'/tests/edit/' + test.uuid" class="btn btn-sm btn-outline-primary" :title="'Edit ' + test.name + ' Details'">Edit</router-link>&nbsp;
                  <router-link :to="'/lessons/' + test.uuid" class="btn btn-sm btn-outline-danger" :title="'Lessons ' + test.name + ' Details'">Lessons</router-link>&nbsp;
                  <button v-on:click="deleteTest(test.uuid)" class="btn btn-sm btn-outline-default" :title="'Delete ' + test.name">
                    <i class="icon icon-trash-alt"></i>
                  </button>
                </p> -->
                <!--  -->
                <img :src="test.image" style="width: 800px" />
                <table class="table">
                  <tr>
                    <th>Name</th>
                    <td>{{ test.name }}</td>
                  </tr>
                  <tr>
                    <th>Introduction</th>
                    <td v-html="test.introduction"></td>
                  </tr>

                  <tr>
                    <th>Prerequisite</th>
                    <td v-html="test.prerequisite"></td>
                  </tr>
                  <tr>
                    <th>Description</th>
                    <td v-html="test.description"></td>
                  </tr>
                </table>
              </div>

              <!-- <div class="card-footer">
                <router-link :to="'/tests/edit/' + test.uuid" class="btn btn-sm btn-outline-primary" :title="'Edit ' + test.name + ' Details'">Edit</router-link>&nbsp;
                <router-link :to="'/lessons/' + test.uuid" class="btn btn-sm btn-outline-danger" :title="'Lessons ' + test.name + ' Details'">Lessons</router-link>&nbsp;
                <button v-on:click="deleteTest(test.uuid)" class="btn btn-sm btn-outline-default" :title="'Delete ' + test.name">
                  <i class="icon icon-trash-alt"></i>
                </button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "TestDetails",
  data() {
    return {
      test: {},
    };
  },

  beforeMount() {
    axios
      .get("/author/tests/" + this.$route.params.uuid)
      .then((res) => {
        this.test = res.data.test;
      })
      .catch((error) => {});
  },
  computed: {},
  methods: {
    deleteTest(uuid) {
      axios.post("/authoring/tests/delete/" + uuid).then((res) => {
        if (res.data.status === "success") {
          this.$swal("Done!", res.data.message, "success");
          this.$router.push("/tests");
        } else {
          this.$swal("Done!", res.data.message, "error");
        }
      });
    },
  },
};
</script>
